import { RESTError } from "../core/RESTError";

/**
 * An error that occurs, when e.g. downloading software for a system,
 * but the underlying system hasn't the minimum requirements for any software.
 */
export class InsufficientSystemRequirementsError extends RESTError {}
